import { useCallback, useContext, useState } from "react";
import { DispSize, WindowContext } from "./WindowContextProvider";
import { MainButton } from "./MainButton";
import { MainMenu, MenuData } from "./MainMenu";
import { ContentWidget } from "./ContentWidget";
import { M1_HR } from "../content/m1_hr";
import { M2_HR } from "../content/m2_hr";
import { M3_HR } from "../content/m3_hr";
import { M4_HR } from "../content/m4_hr";
import { M5_HR } from "../content/m5_hr";
import { M6_HR } from "../content/m6_hr";

export interface BootstrapProps {
    hh: number,
    scale: number,
}

export const Bootstrap = ({hh,scale}: BootstrapProps) : React.JSX.Element => {
    const ds: DispSize = useContext(WindowContext);
    const [mmVisible,setMMVisible] = useState<boolean>(false);
    const [cVisible,setCVisible] = useState<string|null>('m1');

    var menuData = [] as MenuData[];
    const ccback = useCallback((menuId:string) => {
        setMMVisible(false);
        setCVisible(menuId);
    },[]);
    menuData.push({id: 'm1', name: 'O nama', clickCallback: ccback});
    menuData.push({id: 'm2', name: 'Programsko inženjerstvo', clickCallback: ccback});
    menuData.push({id: 'm3', name: 'Analitika, AI/ML/MLops', clickCallback: ccback});
    menuData.push({id: 'm4', name: 'Konzalting', clickCallback: ccback});
    menuData.push({id: 'm5', name: 'Znanstveno-istraživački rad', clickCallback: ccback});
    menuData.push({id: 'm6', name: 'Partnerstva i klijenti', clickCallback: ccback});

    const mmClick = useCallback(() => {
        if(mmVisible) setMMVisible(false);
        else setMMVisible(true);
    }, [mmVisible]) 

    return(
        <>
            <MainButton id='main_button' hh={hh} rspacing={20} ordinal={1} className={'MainMenuButton'} onClick={mmClick}/>
            {mmVisible &&
                <MainMenu data={menuData} hh={hh} setVisible={setMMVisible} />
            }
            {cVisible=='m1' &&
                <ContentWidget title="O nama" hh={hh} scale={scale} imageClass="AboutUsImage">                    
                    <M1_HR />
                </ContentWidget>
            }
            {cVisible=='m2' &&
                <ContentWidget title="Programsko inženjerstvo" hh={hh} scale={scale} imageClass="SoftwareEngineering">
                    <M2_HR />
                </ContentWidget>
            }
            {cVisible=='m3' &&
                <ContentWidget title="Analitika, AI/ML/MLops" hh={hh} scale={scale} imageClass="AI">
                    <M3_HR />
                </ContentWidget>
            }
            {cVisible=='m4' &&
                <ContentWidget title="Konzalting" hh={hh} scale={scale} imageClass="Consulting">
                    <M4_HR />
                </ContentWidget>
            }
            {cVisible=='m5' &&
                <ContentWidget title="Znanstveno-istraživački rad" hh={hh} scale={scale} imageClass="Sci">
                    <M5_HR />
                </ContentWidget>
            }
            {cVisible=='m6' &&
                <ContentWidget title="Partnerstva i klijenti" hh={hh} scale={scale} imageClass="Collab">
                    <M6_HR />
                </ContentWidget>
            }
        </>
    );  
}